export const getPreferredAccount = (accounts = []) => (
  accounts.find(account => (
    account.isPreferred === true
  ))
);

export default getPreferredAccount;
